<template>
  <div>
    <event-section-heading
      v-show="isLoading || events.length > 0"
      :target-label="targetLabel"
    />
    <vertical-event-list
      v-show="events.length > 0"
      :events="events"
    />
    <vertical-dummy-events v-show="isLoading" />
  </div>
</template>

<script>
import { RepositoryFactory } from '../../entry/api/inside/repository_factory'
import VerticalEventList from '../events/vertical_event_list'
import SectionHeading from '../events/section_heading'
import * as Sentry from '@sentry/vue'

export default {
  name: 'VerticalEventTagsEvents',
  components: {
    'vertical-event-list': VerticalEventList,
    'event-section-heading': SectionHeading
  },
  props: {
    targetLabel: {
      type: String,
      required: true
    },
    eventTagIds: {
      type: Array,
      required: true
    },
    excludeEventIds: {
      type: Array
    }
  },
  data () {
    return {
      isLoading: true,
      events: []
    }
  },
  created () {
    const EventTagsFactory = RepositoryFactory.get('event_tags')
    EventTagsFactory.getEvents(this.eventTagIds, this.excludeEventIds)
      .then((response) => {
        this.events = response.data.events
        console.log(this.events)
      })
      .catch((error) => {
        Sentry.captureException(error)
      })
      .finally(() => {
        this.isLoading = false
      })
  }
}
</script>
